import { render, staticRenderFns } from "./PartnerCreateInquiryNew.vue?vue&type=template&id=c29d5f76&scoped=true"
import script from "./PartnerCreateInquiryNew.vue?vue&type=script&lang=js"
export * from "./PartnerCreateInquiryNew.vue?vue&type=script&lang=js"
import style0 from "./PartnerCreateInquiryNew.vue?vue&type=style&index=0&id=c29d5f76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29d5f76",
  null
  
)

export default component.exports